import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'randomOrder',
  standalone: true
})
export class RandomOrderPipe implements PipeTransform {

  transform(name: string, hasPriority = false): string {
    if (name) {
      let orderNumber = +name.toString().charCodeAt(0).toString().charAt(1);
      if (hasPriority) {
        ++orderNumber;
      }

      return `order-${orderNumber}`;
    }
  }
}
